<div class="formulaire">
  <div class="row">
    <div class="col-12">
      <h1>{{ choixSupport.filtreActifs | translate }}</h1>
      <h1 class="custom-h1">{{ choixSupport.filtreDisponibles | translate }}</h1>
    </div>


    <div class="col-12">
      <div class="lineWithStar">
        <h1>{{ choixSupport.libelleChoix | translate }}</h1>
        <!-- Masqué suite au masquage SHAL/JAL -->
        <!-- <app-star-preference class="ml-1" *ngIf="isPrefActivated" preferenceType={{typeDiffusion}}
          (preferenceSelected)="chargeDonneePreference($event)">
        </app-star-preference> -->
        <div class="ml-auto">
          <app-bottom-page ></app-bottom-page>
        </div>
      </div>
      <app-tableau-diffuseur *ngIf="chargeTableau" (formOutput)="getActionOnTab($event)" (presseOutput)="getActionOnPresse($event)" [mode]="1" [tableContent]="tableContent" [form]="form"></app-tableau-diffuseur>
      <div class="lineWithStar">
        <div class="ml-auto">
          <app-top-table-page></app-top-table-page>
        </div>
      </div>
    </div>
  </div>
</div>
